let backendUrl;
console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === 'production') {
  backendUrl = 'https://ab.teleobi.com';
} else {
  backendUrl = 'http://127.0.0.1:5000'; // Use your local development URL
}
export default backendUrl;
